import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { servicios_grupogack_plantillas, plantillas_ } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import { ArrayJsonPlantillas } from '../../../Helpers/JsonToOneLevel';
import DataTableService from '../../../DataTableService/DataTableService';
import AssignPlantilla from './AssignPlantilla';
import EditPlantilla from './EditPlantilla';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const Plantillas = ({ id, permisos }) => {

    const [plantillas, setPlantillas] = useState(null);
    const [mostrarElemento, setMostrarElemento] = useState('none');
    const [item, setItem] = useState({ id: 0 });

    useEffect(() => {
        axios.get(`${servicios_grupogack_plantillas}/all/`, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    const newPlantillas = ArrayJsonPlantillas(res.data.dataResponse)
                    setPlantillas(newPlantillas);
                    break;
                case 404:
                    setPlantillas([]);
                    break;
                default:
                    alert('error');
                    break;
            }
        })
        .catch(error => alert('error'));
    },[]);

    const mostrarComponente = (item = { id: 0 }, type = 'none', dataTable) => {
        setItem(item);
        setMostrarElemento(type);
        if(dataTable) {
            setPlantillas(dataTable);
        }
    };

    return (
        <div id={id}>
            {   
                (mostrarElemento !== 'none')
                ?   (mostrarElemento === 'asignar')
                    ?   <AssignPlantilla plantilla={{ id: item.id, nombre: item.plantillaNom }} onShowTable={mostrarComponente}/>
                    :   (mostrarElemento === 'editar')
                        ?   <EditPlantilla item={item} onShowTable={mostrarComponente} plantillas={plantillas} setPlantillas={setPlantillas}/>
                        :   null
                :   (plantillas)
                    ?   <DataTableService id={id} title={plantillas_}
                            columns={[
                                { field: "plantillaClave", title: "Clave" },
                                { field: "plantillaNom", title: "Nombre" },
                                { field: "plantillaDesc", title: "Descripción" },
                            ]}
                            data={plantillas}
                            permisos={permisos}
                            onShowTable={mostrarComponente}
                            showIconPostAdd
                            showIconChromeReaderMode
                        />
                    :   <SpinnerOval />
            }
        </div>
    );
}
 
export default Plantillas;
